// extracted by mini-css-extract-plugin
module.exports = {"triggerWrapper":"_3A6b4awD","fullWidth":"_1ZBMxmBM"};